/**
 * @fileoverview Estado da triagem de cada OS na tela "Ordens de serviço": a chave
 * (a mesma do servidor, que filtra, conta e ordena por ela, e manda a contagem
 * já na ordem da barra), o rótulo e o tom de cor, os mesmos do painel da
 * triagem no chat.
 */

import { i18n } from "../../translate/i18n";
import { SESSION_TONE, toneOf } from "../../components/Triage/helpers";

// Na tela de OS, a cancelada precisa se distinguir da não iniciada (cinza) num
// relance: vermelho. No painel da triagem no chat ela continua neutra (lá, cancelar
// é rotina: a conversa encerrada pelo atendente também cancela).
const TONE_ON_THIS_SCREEN = { cancelled: "bad" };

// Estados que não são o de uma triagem: o motivo da espera ou o início automático da OS.
const WORK_ORDER_STATES = {
  waiting_human: { label: "workOrders.triage.chips.waitingHuman", tone: "wait" },
  scheduled: { label: "workOrders.triage.chips.scheduled", tone: "neutral" },
  not_started: { label: "workOrders.triage.chips.failed", tone: "neutral" },
  none: { label: "workOrders.triage.chips.none", tone: "neutral" },
};

/**
 * Chave do estado: a que veio do servidor (lista) ou, de uma triagem do painel
 * da OS, a calculada pela mesma regra dele.
 */
export const triageStateOf = (tr) => {
  if (!tr) return "none";
  if (tr.state) return tr.state;
  if (tr.status) {
    return tr.status === "PENDING" && tr.attentionReason === "ticket_with_human" ? "waiting_human" : tr.status.toLowerCase();
  }
  if (tr.failed) return "not_started";
  if (tr.nextAttemptAt) return "scheduled";
  return "none";
};

export const triageStateLabel = (state) =>
  WORK_ORDER_STATES[state] ? i18n.t(WORK_ORDER_STATES[state].label) : i18n.t(`triage.sessionStatus.${String(state).toUpperCase()}`);

/** Tom de cor (ok, info, wait, bad, neutral), os do painel da triagem (menos a cancelada). */
export const triageStateTone = (state) =>
  WORK_ORDER_STATES[state]?.tone || TONE_ON_THIS_SCREEN[state] || toneOf(SESSION_TONE, String(state).toUpperCase());

/** Classes do selo do estado (styles da tela): o cinza é o chip comum, os outros ganham o tom. */
export const triageChipClass = (classes, state) =>
  [classes.chip, classes.triageChip, classes[`pill_${triageStateTone(state)}`]].filter(Boolean).join(" ");
